<template>
  <div class="small text-right pt-2 global-source">
    資料來源網址：<a target="_blank" :href="href">{{ text }}</a>
  </div>
</template>
<script>
export default {
  name: "DataSource",
  props: {

    //資料來源標題
    text: {   
      type: String,
      default: ""
    },
    //資料來源網址
    href: {   
      type: String,
      default: ""
    }

  }
};
</script>
